// extracted by mini-css-extract-plugin
module.exports = {"BubbleContentsNext":"healthCheckTooltips_BubbleContentsNext__3-KwU","buttonSeparator":"healthCheckTooltips_buttonSeparator__2dyTE"};